export default "__VITE_ASSET__68c4a0d7__"